var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tripBudget" },
    [
      _c("update-budget", {
        attrs: { budgetList: _vm.budgetList, chenckBudget: _vm.checkBudget },
      }),
      _c("budget-detail", {
        attrs: {
          checkBudget: _vm.checkBudget,
          chooseStockTypes: _vm.chooseStockTypes,
          showCostPrice: _vm.showCostPrice,
          allStockTypes: _vm.allStockTypes,
          planProductShowStatus: _vm.planProductShowStatus,
        },
        on: { selectLinkProduct: _vm.selectLinkProduct },
      }),
      _c("link-product-dialog", {
        ref: "linkProduct",
        attrs: { checkBudget: _vm.checkBudget },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }